export default {
  USER_MANAGEMENT: 'canViewUserManagement',
};
